import { Component } from '@angular/core';

import { GenericPageComponent } from '../../generic-page.component';

@Component({
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.css']
})
export class StartComponent extends GenericPageComponent {}
